var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-replenish-total"},[_c('h1',[_vm._v("How do I replenish the total balance of my business account (Deposit)?")]),_c('p',[_vm._v(" Request an invoice for payment: ")]),_c('ol',[_c('li',[_vm._v("Through a support request")]),_c('li',[_vm._v("Via an available communication channel from a web service specialist")])])])
}]

export { render, staticRenderFns }